// Get Technology Fields
export const GET_BADGE_FIELDS_REQUEST = "GET_BADGE_FIELDS_REQUEST";
export const GET_BADGE_FIELDS_SUCCESS = "GET_BADGE_FIELDS_SUCCESS";
export const GET_BADGE_FIELDS_FAIL = "GET_BADGE_FIELDS_FAIL";
export const GET_BADGE_FIELDS_RESET = "GET_BADGE_FIELDS_RESET";

// Get Quiz Details
export const GET_BADGE_QUIZ_REQUEST = "GET_BADGE_QUIZ_REQUEST";
export const GET_BADGE_QUIZ_SUCCESS = "GET_BADGE_QUIZ_SUCCESS";
export const GET_BADGE_QUIZ_FAIL = "GET_BADGE_QUIZ_FAIL";
export const GET_BADGE_QUIZ_RESET = "GET_BADGE_QUIZ_RESET";

// Submit Quiz
export const SUBMIT_BADGE_QUIZ_REQUEST = "SUBMIT_BADGE_QUIZ_REQUEST";
export const SUBMIT_BADGE_QUIZ_SUCCESS = "SUBMIT_BADGE_QUIZ_SUCCESS";
export const SUBMIT_BADGE_QUIZ_FAIL = "SUBMIT_BADGE_QUIZ_FAIL";
export const SUBMIT_BADGE_QUIZ_RESET = "SUBMIT_BADGE_QUIZ_RESET";

export const SELECTED_TECH_FIELD = "SELECTED_TECH_FIELD";

export const GET_QUIZ_RESULT_BY_ID_REQUEST = "GET_QUIZ_RESULT_BY_ID_REQUEST";
export const GET_QUIZ_RESULT_BY_ID_SUCCESS = "GET_QUIZ_RESULT_BY_ID_SUCCESS";
export const GET_QUIZ_RESULT_BY_ID_FAIL = "GET_QUIZ_RESULT_BY_ID_FAIL";
export const GET_QUIZ_RESULT_BY_ID_RESET = "GET_QUIZ_RESULT_BY_ID_RESET";

export const GET_DASHBOARD_BADGE_QUIZ_REQUEST =
  "GET_DASHBOARD_BADGE_QUIZ_REQUEST";
export const GET_DASHBOARD_BADGE_QUIZ_SUCCESS =
  "GET_DASHBOARD_BADGE_QUIZ_SUCCESS";
export const GET_DASHBOARD_BADGE_QUIZ_FAIL = "GET_DASHBOARD_BADGE_QUIZ_FAIL";
